import { ISetAuthLoading } from './actions';
import IAuthState, {
  AUTHENTICATE,
  IAuthenticate,
  IUnauthenticate,
  UNAUTHENTICATE,
  SET_AUTH_LOADING,
} from './types';

// export interface AuthState {
//     uuid?: string;
//     isAuthenticated?: boolean;
// }

const initialState: IAuthState = {
  user: undefined,
  isAuthenticated: undefined,
  isLoading: false, // Add default loading state
};

export default function authReducer(
  state: IAuthState = initialState,
  action: IAuthenticate | IUnauthenticate | ISetAuthLoading
): IAuthState {
  switch (action.type) {
    case AUTHENTICATE:
      return {
        ...state,
        user: action.user,
        isAuthenticated: true,
        isLoading: false,
      };
    case UNAUTHENTICATE:
      return {
        user: undefined,
        isAuthenticated: false,
        isLoading: false,
      };
    case SET_AUTH_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    default:
      return state;
  }
}
